const config = {
    acceptedExtensions: ['.pdf', '.doc', '.docx', '.rtf'],
    maxFileSize: 50000000,
    apiUrl: process.env.VUE_APP_API_URL || 'http://php:8000/api',
};

export default config;
